<template>
    <div v-show="isActive">
        <slot></slot>
    </div>
</template>

<script>
export default {
    props: ["name", "selected", "attributes"],

    data() {
        return { isActive: false, isShown: false };
    },

    computed: {
        href() {
            return "#" + this.name.replace(/\s+/g, "-").toLowerCase();
        }
    },

    mounted() {
        this.isActive = this.selected;
    }
};
</script>
